"use strict";

exports.__esModule = true;
exports["default"] = exports.PAST_DATE_PICKER_DEFAULT_PROPS = exports.DEFAULT_PROPS_2 = void 0;
var DEFAULT_PROPS = {
  resourceType: 'Form_1_0_0',
  leadFormType: 'example-form',
  leadFormDescription: 'Example Lead Form Description',
  thankYouMessage: {
    title: "We've received your request",
    text: "We aim to confirm your test drive within 24 hours - bit we're usually quicker than that"
  },
  formComponents: [{
    resourceType: 'TextField_1_0_0',
    fieldName: 'simple-example',
    fieldLabel: 'Single Line text d',
    constraints: [{
      constraintType: 'alphanumeric',
      regex: '[a-zA-Z0-9]+',
      validationMessage: 'Must be a valid text'
    }],
    inputType: 'text',
    isRequired: true,
    requiredMessage: 'Enter some text into this field.',
    numberOfLines: 1,
    value: '',
    helpMessage: 'Must be a valid text'
  }, {
    resourceType: 'ChoiceType_1_0_0',
    fieldName: 'radio-example',
    fieldLabel: 'Radio Buttons',
    isRequired: true,
    requiredMessage: 'Select an option',
    options: [{
      key: '1',
      label: 'Option 1',
      active: true,
      disabled: false
    }, {
      key: '2',
      label: 'Option 2',
      active: false,
      disabled: false
    }, {
      key: '3',
      label: 'Option 3',
      active: false,
      disabled: true
    }],
    choiceFieldType: 'radio',
    value: '',
    helpMessage: 'Click a label to select'
  }, {
    resourceType: 'ChoiceType_1_0_0',
    fieldName: 'select-example',
    fieldLabel: 'Select Buttons',
    isRequired: true,
    requiredMessage: 'Select an option',
    placeholderText: 'Select your option',
    options: [{
      key: '1',
      label: 'Option 1',
      active: false,
      disabled: false
    }, {
      key: '2',
      label: 'Option 2',
      active: false,
      disabled: false
    }, {
      key: '3',
      label: 'Option 3',
      active: false,
      disabled: true
    }],
    choiceFieldType: 'select',
    value: '',
    helpMessage: 'Choose an option from the menu'
  }, {
    resourceType: 'ChoiceType_1_0_0',
    fieldName: 'checkbox-example',
    fieldLabel: 'Checkbox Buttons',
    isRequired: true,
    requiredMessage: 'Select an option',
    options: [{
      key: '1',
      label: 'Option 1',
      active: true,
      disabled: false
    }, {
      key: '2',
      label: 'Option 2',
      active: false,
      disabled: false
    }, {
      key: '3',
      label: 'Option 3',
      active: false,
      disabled: true
    }],
    choiceFieldType: 'checkbox',
    value: '',
    helpMessage: 'Click a label to select'
  }, {
    resourceType: 'TextField_1_0_0',
    fieldName: 'number-example',
    fieldLabel: 'Amount',
    constraints: [{
      constraintType: 'number',
      regex: '[0-9]',
      validationMessage: 'helpMessage'
    }],
    inputType: 'number',
    isRequired: true,
    requiredMessage: 'Enter the desired amount',
    numberOfLines: 1,
    value: '',
    helpMessage: 'Must be a whole number'
  }, {
    __typename: 'TextField',
    resourceType: 'TextField_1_0_0',
    fieldName: 'date-example',
    fieldLabel: 'Date - Default',
    constraints: [{
      constraintType: 'date',
      regex: '^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\\d\\d$',
      validationMessage: 'Please use dd/mm/yyyy format'
    }],
    inputType: 'date',
    isRequired: true,
    requiredMessage: 'Enter a date',
    value: '',
    helpMessage: 'Must be a valid date',
    previousLabel: 'Previous',
    nextLabel: 'Next',
    weekStartDay: 1
  }, {
    resourceType: 'TextField_1_0_0',
    fieldName: 'text-example',
    fieldLabel: 'Email',
    constraints: [{
      constraintType: 'email',
      regex: "(?:[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|'(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*')@(?:(?:[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9](?:[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9-]*[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9])?\\.)+[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9](?:[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9-]*[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])",
      validationMessage: 'helpMessage'
    }],
    inputType: 'email',
    isRequired: true,
    requiredMessage: 'Enter your email address',
    numberOfLines: 1,
    value: '',
    helpMessage: 'Must contain an @ symbol'
  }, {
    resourceType: 'TextField_1_0_0',
    fieldName: 'textarea-example',
    fieldLabel: 'Your message',
    constraints: [{
      constraintType: 'alphanumeric',
      regex: '[a-zA-Z0-9]+',
      validationMessage: 'Must contain a message'
    }],
    inputType: 'textarea',
    isRequired: false,
    requiredMessage: 'Enter your message',
    numberOfLines: 4,
    value: '',
    helpMessage: 'Must contain a message',
    usePlaceholder: false,
    hideTitle: true
  }, {
    resourceType: 'Form_Button_1_0_0',
    type: 'submit',
    name: 'submit-example',
    value: '',
    label: 'Onward and Upward'
  }, {
    resourceType: 'FormColumnControl_1_0_0',
    columns: [{
      components: [{
        __typename: 'TextField',
        resourceType: 'TextField_1_0_0',
        fieldName: 'first-name',
        fieldLabel: 'First Name',
        inputType: 'text',
        isRequired: true,
        requiredMessage: 'Please enter a name.',
        value: '',
        helpMessage: 'Must be a valid text'
      }]
    }, {
      components: [{
        __typename: 'TextField',
        resourceType: 'TextField_1_0_0',
        fieldName: 'last-name',
        fieldLabel: 'Surname',
        inputType: 'text',
        isRequired: false,
        requiredMessage: 'Please enter a surname.',
        value: '',
        helpMessage: 'Must be a valid text'
      }]
    }]
  }],
  requiredMessage: 'Please fill out all fields',
  buttonLabel: 'Submit Default',
  errorMessage: 'Unexpected error from server',
  backgroundColour: 'light',
  formAlignment: 'inset',
  buttonAlignment: 'bottom',
  showRecaptcha: false,
  recaptchaSiteKey: ''
};

// eslint-disable-next-line import/prefer-default-export
var DEFAULT_PROPS_2 = {
  id: 'US_en_1611139751719',
  resourceType: 'Constructed_Form_1_0_0',
  lastModified: '1611139751719',
  leadFormType: 'request-a-quote',
  leadFormDescription: null,
  thankYouMessage: {
    text: "We aim to confirm your appointment within 24 hours – but we’re usually quicker than that. We'll be in touch by your preferred method.",
    title: "We've received your request"
  },
  formComponents: [{
    resourceType: 'MiniDealerLocator_1_0_0',
    disclaimerData: null,
    title: '02 Select a Dealer',
    headingTag: null,
    subHeadline: 'Pick a dealership Test',
    searchFieldLabel: 'Address',
    searchHelpText: 'Enter postcode or location',
    locationCtaLabel: 'Use Current Location',
    viewMoreText: 'View More',
    preSelectedFilter: 'sales',
    searchRadius: 200,
    metricSystem: 'imperial',
    showRating: true,
    noGeolocationMessage: 'No Geolocation captured.',
    noDealershipFoundMessage: 'No Dealership found near you',
    isRequired: true,
    requiredMessage: 'Please select a dealer',
    isFilterDealersBySelectedVehicle: true,
    vehicleUnavailableErrorMessage: null,
    advanceFilter: true,
    limitReturningDealers: '3',
    allowMultiDealersSelectionforSubmitForm: true,
    enableTheSearchPostcode: false,
    constraints: [{
      constraintType: 'alphanumeric',
      regex: '^[\\w]{2,}\\|[\\w]{2,}',
      validationMessage: 'Please select a dealer',
      displayFormat: ''
    }]
  }, {
    resourceType: 'TextBlock_1_0_0',
    disclaimerLabel: null,
    useAccordion: null,
    paragraph: '<h4><strong>2.  Add your contact details</strong></h4>\r\n',
    sectionHeading: '',
    mainHeading: '',
    theme: null,
    textAlignment: 'left',
    width: 'span100'
  }, {
    id: 'US_en_1611027274076',
    resourceType: 'FormColumnControl_1_0_0',
    columns: [{
      components: [{
        resourceType: 'TextField_1_0_0',
        fieldName: 'firstName',
        fieldLabel: 'First Name',
        constraints: [null],
        isRequired: true,
        requiredMessage: null,
        helpMessage: null,
        value: null,
        inputType: 'text',
        previousLabel: null,
        nextLabel: null,
        weekStartDay: null,
        maxLength: null
      }, {
        resourceType: 'TextField_1_0_0',
        fieldName: 'email',
        fieldLabel: 'Email',
        constraints: [{
          constraintType: 'email',
          regex: "(?:[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|'(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*')@(?:(?:[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9](?:[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9-]*[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9])?\\.)+[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9](?:[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9-]*[\\u00A0-\\uD7FF\\uE000-\\uFFFF-a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])$",
          validationMessage: null
        }],
        isRequired: true,
        requiredMessage: null,
        helpMessage: null,
        value: null,
        inputType: 'email',
        previousLabel: null,
        nextLabel: null,
        weekStartDay: null,
        maxLength: null
      }, {
        resourceType: 'TextField_1_0_0',
        fieldName: 'addressLine1',
        fieldLabel: 'Address line 1 (Optional)',
        constraints: [null],
        isRequired: false,
        requiredMessage: null,
        helpMessage: null,
        value: null,
        inputType: 'text',
        previousLabel: null,
        nextLabel: null,
        weekStartDay: null,
        maxLength: null
      }]
    }, {
      components: [{
        resourceType: 'TextField_1_0_0',
        fieldName: 'lastName',
        fieldLabel: 'Last Name',
        constraints: [null],
        isRequired: true,
        requiredMessage: null,
        helpMessage: null,
        value: null,
        inputType: 'text',
        previousLabel: null,
        nextLabel: null,
        weekStartDay: null,
        maxLength: null
      }, {
        resourceType: 'TextField_1_0_0',
        fieldName: 'phone',
        fieldLabel: 'Phone number (Optional)',
        constraints: [{
          constraintType: 'number',
          regex: '^[0-9]{2,3}-? ?[0-9]{6,7}$',
          validationMessage: null
        }],
        isRequired: false,
        requiredMessage: null,
        helpMessage: null,
        value: null,
        inputType: 'tel',
        previousLabel: null,
        nextLabel: null,
        weekStartDay: null,
        maxLength: null
      }, {
        resourceType: 'TextField_1_0_0',
        fieldName: 'addressLine2',
        fieldLabel: 'Address line 2 (Optional)',
        constraints: [null],
        isRequired: false,
        requiredMessage: null,
        helpMessage: null,
        value: null,
        inputType: 'text',
        previousLabel: null,
        nextLabel: null,
        weekStartDay: null,
        maxLength: null
      }]
    }]
  }, {
    resourceType: 'ChoiceType_1_0_0',
    fieldName: 'terms-conditions',
    fieldLabel: '',
    constraints: null,
    isRequired: true,
    requiredMessage: 'Please ensure all required fields are completed',
    helpMessage: '',
    value: '',
    options: [{
      key: '1',
      label: 'Send me communications about upcoming events and promotions via text message. Standard text messaging and data rates may apply.',
      active: false,
      disabled: false
    }],
    choiceFieldType: 'checkbox',
    fieldLongDescription: {
      title: '',
      text: ''
    }
  }],
  steps: null,
  buttonLabel: 'SUBMIT',
  requiredMessage: 'Please ensure all required fields are completed',
  errorMessage: 'It looks like something has gone wrong, please try again.',
  personalDataUtilizationLabel: '',
  personalDataUtilizationDescription: '',
  personalDataUtilizationAgreementLabel: '',
  termsAndConditionsLabel: '',
  termsAndConditionsDescription: '',
  termsAndConditionsAgreementLabel: 'Send me communications about upcoming events and promotions via text message. Standard text messaging and data rates may apply.',
  brochureFileDownloadLabel: null,
  CTAs: []
};
exports.DEFAULT_PROPS_2 = DEFAULT_PROPS_2;
var PAST_DATE_PICKER_DEFAULT_PROPS = {
  id: 'gb_en_1615881549964',
  resourceType: 'Constructed_Form_1_0_0',
  lastModified: '1615881549964',
  leadFormType: '',
  leadFormDescription: null,
  thankYouMessage: {
    title: null,
    text: null
  },
  requiredMessage: '',
  errorMessage: '',
  buttonLabel: '',
  CTAs: [],
  brochureFileDownloadLabel: null,
  backgroundColour: 'light',
  formAlignment: 'inset',
  buttonAlignment: 'bottom',
  formComponents: [{
    resourceType: 'DatePickerField_1_0_0',
    fieldLabel: 'Birthday',
    datePickerFieldName: 'birthday',
    constraints: [{
      constraintType: 'date',
      regex: '^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\\d\\d$',
      validationMessage: 'invalid format',
      displayFormat: 'dd-mm-yyyy'
    }],
    datePickerFieldRequired: true,
    requiredMessage: "It's required field",
    helpMessage: 'Birthday',
    value: null,
    inputType: 'date',
    weekStartDay: 1,
    fieldName: 'birthday',
    isRequired: true
  }],
  steps: null
};
exports.PAST_DATE_PICKER_DEFAULT_PROPS = PAST_DATE_PICKER_DEFAULT_PROPS;
var _default = DEFAULT_PROPS;
exports["default"] = _default;